import React from "react";

import { Navigate } from "react-router-dom";

import {
  getSignupResumePath,
  shouldRedirectIncompleteSignupToResume,
} from "../components/helpers/utils";

const SignupCompletionGuard = ({ children }) => {
  if (shouldRedirectIncompleteSignupToResume()) {
    return <Navigate to={getSignupResumePath()} replace />;
  }

  return children;
};

export default SignupCompletionGuard;
